import { Component, input } from '@angular/core';

@Component({
  selector: 'assessment-row',
  template: `
  <div class="container">
    <div class="header">
      <h3 class="title">{{ title() }}</h3>
      @if (subtitle()) {
      <i class="subtitle">{{ subtitle() }}</i>
      }
      @if (description()) {
      <p class="description">{{ description() }}</p>
      }
    </div>
    <div class="content-container">
      <ng-content class="content"></ng-content>
    </div>
  </div>`,
  styles: `
  .container {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }
  .header {
    flex: 1;

    .title {
      margin-bottom: 0;
      font-weight: bold;
    }
  }
  .content-container {
    flex: 2;
    align-items: center;
    padding-top: 1rem;
  }
  `,
  standalone: true,
})
export class AssessmentRowComponent {
  title = input('');
  subtitle = input('');
  description = input('');
}
